import React from 'react';
import { ExpiredOverlay } from './styles';
import { cx } from '@linaria/core';
import { Typo } from '../../primitives/Typo';
function Expired() {
    /** JSX */
    return React.createElement("div", { className: cx(ExpiredOverlay.base, Typo.base, Typo.info02) }, "Video leider nicht mehr verf\u00FCgbar.");
}
export default Expired;
